/**
 * @author sai shiva
 * @Date: 2022-09-13 14:35:11
 * @Last Modified by: sai shiva
 * @Last Modified time: 2022-09-13 16:20:42
 */

import React, { PureComponent } from 'react';
import { shape } from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, List, Avatar, Card } from 'antd';
import { AppWrappperHOC } from '../Root/HOC';
import StyledWearables from './StyledWearables';
import endPoints from '../../config/endPoints';
import { Container, HelmetWrapper, LandingContainer, SubTitle } from '../../components';
import { LINK_ANDROID_APP, LINK_IOS_APP } from '../HeaderContainer/constants';
import { constants } from '../../devUtils';
import { WEARABLE_CONSTANTS } from './constants';
import LandingJourney from '../NewLanding/Journey';
import LandingTrusted from '../NewLanding/Trusted';
import { IMG_IMPORTS } from '../../devUtils/assests';

class Wearables extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      type: 'Download Zaggle App',
    };
  }

  renderLoginSigupWearable() {
    return (
      <Row type="flex" align="middle" justify="start">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <h2 className="font-16 margin-b-2">
            Signup to the Zaggle APP by entering your name, mobile, email id and password
          </h2>
          <Link to={constants.LINK_FAQS} className="btn white-btn">Visit our FAQ Page</Link>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-right">
          <img
            src={IMG_IMPORTS.WEARABLES_LOGIN_SINGUP_IMAGE.URL}
            alt={IMG_IMPORTS.WEARABLES_LOGIN_SINGUP_IMAGE.ALT}
            className="width-8"
          />
        </Col>
      </Row>
    );
  }

  renderCompleteKycWearable() {
    return (
      <Row type="flex" align="middle" justify="start">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <h2 className="font-16">
             Enter details to complete the KYC and create your MPIN
          </h2>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-right">
          <img
            src={IMG_IMPORTS.WEARABLES_COMPLETE_KYC.URL}
            alt={IMG_IMPORTS.WEARABLES_COMPLETE_KYC.ALT}
            className="width-8"
          />
        </Col>
      </Row>
    );
  }

  renderActivateKeyFobWearable() {
    return (
      <Row type="flex" align="middle" justify="start">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <h2 className="font-16 margin-b-2">
            With one click, you can activate your device and you are good to go. For further details, you can check the FAQs.
          </h2>
          <Link to={constants.LINK_FAQS} className="btn white-btn">Visit our FAQ Page</Link>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-right">
          <img
            src={IMG_IMPORTS.WEARABLES_ACTIVE_KEY_FOB.URL}
            alt={IMG_IMPORTS.WEARABLES_ACTIVE_KEY_FOB.ALT}
            className="width-8"
          />
        </Col>
      </Row>
    );
  }

  renderDownloadZaggleAppWearable() {
    return (
      <Row type="flex" align="middle" justify="start">
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <h2 className="font-16 margin-t-4">
            The Zaggle app is available for both Android and IOS phones.
          </h2>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className="know-connect margin-t-8">
          <p className="font-12">Link to download Zaggle Mobile APP</p>
          <Link to={LINK_ANDROID_APP} target="_blank">
            <img src={endPoints.ZAGGLE_PLAY_STORE.URL} alt={endPoints.ZAGGLE_PLAY_STORE.ALT} className="app-logos margin-r-1" />
          </Link>
          <Link to={LINK_IOS_APP} target="_blank">
            <img src={endPoints.ZAGGLE_APP_STORE.URL} alt={endPoints.ZAGGLE_APP_STORE.ALT} className="app-logos" />
          </Link>
        </Col>
      </Row>
    );
  }

  renderWearablePoints(type) {
    switch (type) {
      case 'Login or Signup':
        return this.renderLoginSigupWearable();
      case 'Complete KYC':
        return this.renderCompleteKycWearable();
      case 'Activate your key fob':
        return this.renderActivateKeyFobWearable();
      default:
        return this.renderDownloadZaggleAppWearable();
    }
  }

  render() {
    const { type } = this.state;
    const {
      WEARABLE_KEYPOINTS,
      WEARABLE_AVAILABLES,
      WEARABLE_GIFT_REMEMBER_CONTENT_ONE,
      WEARABLE_GIFT_REMEMBER_CONTENT_TWO,
      WEARABLE_ZAKEY_ONE,
      WEARABLE_ZAKEY_TWO,
      WEARABLE_ZAKEY_ZAGGLE,
      WEARBLE_CAFETERIA,
      WEARABLE_TRANSIT_SOLUTION,
    } = WEARABLE_CONSTANTS;
    const { location } = this.props;
    return (
      <StyledWearables>
        <HelmetWrapper location={location} />
        <div className="first-content-bg">
          <Container>
            <Row align="middle" type="flex" justify="start" gutter={12}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <h1 className="font-30 padding-b-4">
                  Innovative and Futuristic<br />
                  Corporate Gifting Solution to<br />
                  Dazzle your Partners and <br />
                  Employees.
                </h1>
                <Col xs={24} sm={24} md={14} lg={14} xl={14} className="know-connect">
                  <p className="font-12">Link to download Zaggle Mobile APP</p>
                  <Link to={LINK_ANDROID_APP} target="_blank">
                    <img src={endPoints.ZAGGLE_PLAY_STORE.URL} alt={endPoints.ZAGGLE_PLAY_STORE.ALT} className="app-logos margin-r-1" />
                  </Link>
                  <Link to={LINK_IOS_APP} target="_blank">
                    <img src={endPoints.ZAGGLE_APP_STORE.URL} alt={endPoints.ZAGGLE_APP_STORE.ALT} className="app-logos" />
                  </Link>
                </Col>
                <Col xs={24} sm={24} md={10} lg={10} xl={10} className="padding-l-1">
                  <p className="font-12">Want to know More ?</p>
                  <Link to={constants.LINK_CONTACTUS} className="btn red-btn">Contact Us</Link>
                </Col>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-right">
                <img
                  src={IMG_IMPORTS.WEARABLES_LANDING_IMAGE.URL}
                  alt={IMG_IMPORTS.WEARABLES_LANDING_IMAGE.ALT}
                  className="width-9"
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="third-content-bg padding-t-5">
          <Container>
            <Row align="middle" type="flex" justify="start" gutter={6}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <img
                  src={IMG_IMPORTS.WEARABLES_GADGET_BOX_IMAGE.URL}
                  alt={IMG_IMPORTS.WEARABLES_GADGET_BOX_IMAGE.ALT}
                  className="width-8"
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <SubTitle fontWeight="800" className="font-24">A Gift to Remember</SubTitle>
                <div dangerouslySetInnerHTML={{ __html: WEARABLE_GIFT_REMEMBER_CONTENT_ONE }} className="margin-b-2" />
                <div dangerouslySetInnerHTML={{ __html: WEARABLE_GIFT_REMEMBER_CONTENT_TWO }} />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="third-content-bg padding-tb-1">
          <Container>
            <Row align="middle" type="flex" justify="space-between" gutter={6}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <SubTitle fontWeight="800" className="font-24">What is Zakey?</SubTitle>
                <div dangerouslySetInnerHTML={{ __html: WEARABLE_ZAKEY_ONE }} className="margin-b-2" />
                <div dangerouslySetInnerHTML={{ __html: WEARABLE_ZAKEY_TWO }} />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-center">
                <img
                  src={IMG_IMPORTS.WEARABLES_GADGET_IMAGE.URL}
                  alt={IMG_IMPORTS.WEARABLES_GADGET_IMAGE.ALT}
                  className="width-6"
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="third-content-bg padding-tb-2">
          <Container>
            <List
              itemLayout="vertical"
              dataSource={WEARABLE_KEYPOINTS}
              grid={{ gutter: 16, xs: 1, sm: 1, md: 3, lg: 3, xl: 3, xxl: 3 }}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    className="margin-b-4 padding-1"
                    avatar={<Avatar src={item.avatar_src} alt={item.avatar_alt} className="iconic-wearable" />}
                    title={
                      <h2 className="font-18">
                        <strong>{item.title}</strong>
                      </h2>}
                    description={item.desc}
                  />
                </List.Item>
              )}
            />
          </Container>
        </div>
        <div className="third-content-bg padding-tb-1">
          <Container>
            <Row align="middle" type="flex" justify="start" gutter={12}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <img
                  src={IMG_IMPORTS.WEARABLES_CAFETERIA_SOLUTION.URL}
                  alt={IMG_IMPORTS.WEARABLES_CAFETERIA_SOLUTION.ALT}
                  className="width-8"
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <SubTitle fontWeight="800" className="font-24">Cafeteria Solutions</SubTitle>
                <div dangerouslySetInnerHTML={{ __html: WEARBLE_CAFETERIA }} className="font-14" />
              </Col>
            </Row>
            <Row className="padding-tb-4" align="middle" type="flex" justify="start" gutter={12}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <SubTitle fontWeight="800" className="font-24">Transit Solutions</SubTitle>
                <div dangerouslySetInnerHTML={{ __html: WEARABLE_TRANSIT_SOLUTION }} className="font-14" />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <img
                  src={IMG_IMPORTS.WEARABLES_TRANSIT_SOLUTION.URL}
                  alt={IMG_IMPORTS.WEARABLES_TRANSIT_SOLUTION.ALT}
                  className="width-8"
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="padding-tb-8">
          <LandingContainer>
            <Row align="middle" type="flex" justify="center" gutter={6}>
              <Col xs={24} sm={24} md={18} lg={18} xl={18} className="text-center">
                <SubTitle fontWeight="800" className="font-24">Get Started with Zakey</SubTitle>
                <div dangerouslySetInnerHTML={{ __html: WEARABLE_ZAKEY_ZAGGLE }} />
              </Col>
            </Row>
          </LandingContainer>
        </div>
        <div className="third-content-bg padding-tb-4">
          <LandingContainer>
            <Row align="middle" type="flex" justify="space-between" gutter={0}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                {WEARABLE_AVAILABLES.map((items) => (
                  <div
                    key={items.key}
                    className={type === items.title ? 'link-change active' : 'link-change'}
                    onClick={() => this.setState({ type: items.title })}
                    role="presentation"
                  >
                    <span>{items.key}</span>
                    {items.title}
                  </div>
                ))}
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Card className="card-padding-20 wearable-points">
                  {this.renderWearablePoints(type)}
                </Card>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <p>For further details, you can check the FAQs</p>
              </Col>
            </Row>
          </LandingContainer>
        </div>
        <LandingTrusted />
        <LandingJourney />
      </StyledWearables>
    );
  }
}

Wearables.propTypes = {
  location: shape({}).isRequired,
};

export default (AppWrappperHOC(Wearables));
export { Wearables };




// WEBPACK FOOTER //
// client/containers/Wearables/index.jsx